import { ROUTES_COMMON } from '../common/routesCommonConstants';

export const ROUTES_DE = {
    apply: 'apply',
    applyPage: 'applypage',
    cancelFlow: 'cancelFlow',
    changeInstallment: 'changeInstallment',
    contractPage: 'contractpage',
    contractPageApi: 'contractpageapi',
    creditContract: 'creditContract',
    creditContractFromSession: 'creditContractFromSession',
    cycoPage: 'cycopage',
    decision: 'decision',
    decisionPage: 'decisionpage',
    errorFlow: 'errorFlow',
    errorPage: 'errorPage',
    refreshCaptcha: 'refreshCaptcha',
    returnFlow: 'returnFlow',
    sendFPTIData: ROUTES_COMMON.sendFPTIData,
    sepaApi: 'sepaapi',
    sepaPage: 'sepapage',
    submitApi: 'submitapi',
    submitCycoApi: 'cycopageapi',
    repaymentPage: 'repaymentpage',
    personalinfoPage: 'personalinfopage',
    termsPage: 'termspage',
    payInFullNowFlow: 'payInFullNowFlow'
};
